$(function () {
  let section = $('#seccionClientes')
  if (section.get(0) == null) {
    return
  }
  let vueApp = new Vue({
    el: section.get(0),
    data: {
      loader: false,
      filtros: { page: 1, buscar: null},
      clientes: [],
      cliente: [],

    },
    mounted() {
      this.getClientes()
    },
    methods: {
      getClientes(pagina = null) {
        if (this.loader) {
          return
        }
        if (pagina != null) {
          this.filtros.page = pagina
        }
        this.loader = true
        axios
          .get('/admin/clientes/json', {
            params: this.filtros,
          })
          .then((response) => {
            vueApp.loader = false
            if (response.data.error) {
              swal(response.data.error, "", "info")
              return
            }
            vueApp.clientes = response.data.clientes.data;
            vueApp.filtros.total = response.data.clientes.total;
            vueApp.filtros.per_page = response.data.clientes.per_page;
            vueApp.filtros.from = response.data.clientes.from;
            vueApp.filtros.to = response.data.clientes.to;
          })
          .catch((error) => {
            vueApp.loader = false
            swal("Ocurrió un error inesperado", "", "info")
          })
      },
      eliminar(id) {
        swalQ("¿Eliminar registro?", "", "warning").then((ok) => {
          if (ok) {
            axios
              .delete('/admin/clientes/' + id)
              .then(function (response) {
                if (response.data.error) {
                  swal(response.data.error, "", "info")
                  return
                }
                vueApp.getClientes(1)
              })
              .catch((error) => {
                console.log(error)
                swal("Ocurrió un error inesperado", "", "info")
              })
          }
        })
      },
      cancelarRenovacion(suscripcion) {
        swalQ("¿Cancelar renovación de "+suscripcion.producto.nombre+"?", "", "warning").then((ok) => {
          if (ok) {
            axios
              .delete('/admin/clientes/suscripciones/cancelar/' + suscripcion.id)
              .then(function (response) {
                if (response.data.error) {
                  swal(response.data.error, "", "info")
                  return
                }
                vueApp.getClientes(1)
              })
              .catch((error) => {
                console.log(error)
                swal("Ocurrió un error inesperado", "", "info")
              })
          }
        })
      },
      detalle(cliente){
        this.cliente = Object.assign({}, cliente)
        $('#modalCliente').modal('show')
      }
    },
  })
})
